class CostCalculatorCta extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.abortController = new AbortController();
    this.buttons = Array.from(this.querySelectorAll('[data-eg-cost-size]'));
    this.bottleOutput = this.querySelector('[data-eg-cost-bottle]');
    this.euroguardOutput = this.querySelector('[data-eg-cost-euroguard]');
    this.bottlePerOutput = this.querySelector('[data-eg-cost-bottle-per]');
    this.euroguardPerOutput = this.querySelector('[data-eg-cost-euroguard-per]');
    this.savingsOutput = this.querySelector('[data-eg-cost-savings]');

    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleSizeClick, { signal: this.abortController.signal });
    });

    const activeButton = this.buttons.find((button) => button.classList.contains('is-active')) || this.buttons[0];
    if (activeButton) this.selectSize(activeButton);
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  handleSizeClick = (event) => {
    const button = event.currentTarget;
    if (!(button instanceof HTMLButtonElement)) return;

    this.selectSize(button);
  };

  selectSize(button) {
    this.buttons.forEach((sizeButton) => {
      const isActive = sizeButton === button;
      sizeButton.classList.toggle('is-active', isActive);
      sizeButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.updateCost(this.toNumber(button.dataset.litresPerYear, 0));
  }

  updateCost(litresPerYear) {
    if (!litresPerYear) return;

    const currency = this.dataset.currencySymbol || '';
    const bottlePricePerLitre = this.toNumber(this.dataset.bottlePricePerLitre, 0.41);
    const euroguardYearCost = this.toNumber(this.dataset.euroguardYearCost, 99);
    const periodLabel = this.dataset.periodLabel || 'per year';
    const savingsPrefix = this.dataset.savingsPrefix || 'Save';
    const savingsSuffix = this.dataset.savingsSuffix || '/ year';

    const bottleCost = litresPerYear * bottlePricePerLitre;
    const euroguardCost = euroguardYearCost;
    const savings = Math.max(0, bottleCost - euroguardCost);

    this.setText(this.bottleOutput, this.formatMoney(bottleCost, currency));
    this.setText(this.euroguardOutput, this.formatMoney(euroguardCost, currency));
    this.setText(this.bottlePerOutput, `${periodLabel} · ${currency}${bottlePricePerLitre.toFixed(2)}/L`);
    this.setText(this.euroguardPerOutput, `${periodLabel} · ${currency}${(euroguardCost / litresPerYear).toFixed(2)}/L`);
    this.setText(this.savingsOutput, `${savingsPrefix} ${this.formatMoney(savings, currency)} ${savingsSuffix}`);
  }

  toNumber(value, fallback) {
    const parsed = Number.parseFloat(String(value || '').replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  formatMoney(value, currency) {
    return `${currency}${Math.round(value).toLocaleString('en-GB')}`;
  }

  setText(element, value) {
    if (element instanceof HTMLElement) element.textContent = value;
  }
}

if (!customElements.get('cost-calculator-cta')) {
  customElements.define('cost-calculator-cta', CostCalculatorCta);
}
